export default "__VITE_ASSET__e5d6701d__"